export const convertCompanyNameToSubdomain = (companyName: string): string => {
  if (!companyName) return '';

  return companyName
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^a-z0-9_-]/g, '') // Remove invalid characters
    .replace(/-{2,}/g, '-') // Replace consecutive hyphens with single hyphen
    .replace(/_{2,}/g, '_') // Replace consecutive underscores with single underscore
    .replace(/^[-_]+|[-_]+$/g, ''); // Remove leading/trailing hyphens/underscores
};
